import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import UserContext from "../context/UserContext";
import { login, getOtp, getOtpDirect, loginDirect } from "../Services/Service";
import OTPInput, { ResendOTP } from "otp-input-react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { BottomSheetCustom } from "@cred/neopop-web/lib/components";

const initialValue = {
  userPhonenumber: "",
  password: "",
  username: "",
};

const BottomLoginDirect = ({ reredirect }) => {
  const { state, updateInfo } = useContext(UserContext);
  const [OTP, setOTP] = useState(0);
  const [mobile, setMobile] = useState("");
  const [registerdMobile, setRegisteredMobile] = useState("");

  // console.log(mobile)
  const myForm = useRef();
  const nav = useNavigate();
  const location = useLocation();
  // console.log(location.state);
  const [otp, setOtp] = useState("");
  useEffect(() => {}, []);

  const [user, setUser] = useState(initialValue);
  //  console.log(user)
  const [formErrors, setFormErrors] = useState("");
  const [otpStatus, setOtpStatus] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [time, setTime] = useState(false);
  // console.log(otpStatus)

  const [alertInfo, setAlertInfo] = useState({
    visible: false,
    cls: "",
    msg: "",
  });
  const [alertInfos, setAlertInfos] = useState({
    visible: false,
    cls: "",
    msg: "",
  });
  const onShowAlert = (msg, visible, clas) => {
    setAlertInfo({
      ...alertInfo,
      ["visible"]: visible,
      ["cls"]: clas,
      ["msg"]: msg,
    });
  };

  const onValueChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleClick = (e) => {
    // console.log(e.target.name)
    myForm.current = e.target.name;
  };
  function validateForm(e) {
    if (e === true || e?.target.name === "Send_OTP") {
      if (mobile.length !== 10) {
        // console.log(mobile)
        setFormErrors("Please Enter 10 digit Mobile No.");
        return false;
      } else {
        // console.log(mobile)
        setFormErrors("");
        return true;
      }
    } else {
      if (OTP.length !== 6) {
        setFormErrors("");
        setFormErrors("Please Enter 6 digit OTP");
        return false;
      } else {
        setFormErrors("");
        return true;
      }
    }
  }

  const submitHandle = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }
    if (e === true || e?.target.name === "Send_OTP") {
      let isvalidForm = validateForm(e);
      if (isvalidForm) {
        // $("#otpDiv").show();
        // $("#validOtp").show();
        // $("#getOtp").hide();
        setTime(true);
        getOtpDirect(mobile)
          .then((response) => {
            // console.log(response);
            return response;
          })
          .then((response) => {
            // if(response.data.code === 200){
            if (response.data.data?.status === 1) {
              setMobile(response.data?.data?.mobile);
              setRegisteredMobile(response.data?.data?.registerdMobile);
              setDisabled(true);
              setTimeout(() => {
                clearInterval(setTimer);
                setAlertInfo({
                  ...alertInfo,
                  visible: true,
                  cls: "success",
                  msg: response.data.data.msg,
                });
                setTime(false);
              }, 20000);
              let i = 20;
              const setTimer = setInterval(() => {
                setAlertInfo({
                  ...alertInfo,
                  visible: true,
                  cls: "success",
                  msg: `${response.data.data.msg}. Resend in ${i--}s`,
                });
                // console.log(i--)
              }, 1000);

              setAlertInfo({
                ...alertInfo,
                visible: true,
                cls: "success",
                msg: response.data.data.msg,
              });
              // setTimeout(() => {
              //     setAlertInfo({...alertInfo, 'visible': false,'cls':'success','msg': ``});
              // }, 2000);
            } else {
              setAlertInfos({
                ...alertInfo,
                visible: true,
                cls: "danger",
                msg: response.data.data.msg,
              });
              //   setTimeout(() => {
              //     setAlertInfo({...alertInfo, 'visible': false,'cls':'danger','msg': ``});
              // }, 2000);
            }
            //  }
          });
        const signal = new AbortController();
        setTimeout(() => {
          signal.abort();
        }, 1 * 60 * 1000);
        async function main() {
          // console.log("calld")
          if ("OTPCredential" in window) {
            try {
              if (navigator.credentials) {
                try {
                  await navigator.credentials
                    .get({ abort: signal, otp: { transport: ["sms"] } })
                    .then((content) => {
                      if (content && content.code) {
                        alert(content);
                        alert(content.code);
                      }
                    })
                    .catch((e) => console.log(e));
                } catch (e) {
                  return;
                }
              }
            } catch (err) {
              console.log(err);
            }
          }
        }
        main();
        // })
      }
    } else {
      let isvalidForm = validateForm(e);
      if (isvalidForm) {
        loginDirect(registerdMobile, OTP).then((response) => {
          //  console.log(response.data);
          if (response.data.data.status === 1) {
            // localStorage.setItem('auth', JSON.stringify(response.data.auth));
            localStorage.setItem("auth", response.data.data.auth);
            // localStorage.setItem('token', response.data.data.token);
            setOtpStatus(1);
            updateInfo();

            onShowAlert(`${response.data.data.msg}`, true, "success");
            // console.log(response.data.data.redirect==="/payment")
            if (response.data.data.redirect === `/register`) {
              // console.log(response.data.data.redirect,location.state)
              return nav(`/register`, {
                state: {
                  redirect: response.data.data.redirect,
                  reredirect: location.pathname,
                },
              });
              // return nav(`/${response.data.data.redirect}`)
            } else {
              // console.log(response.data.data.redirect,location.pathname)
              return nav(`/congratulations`, {
                state: { redirect: location.pathname },
              });
              // return nav(`/congratulations`,{state:{redirect:response.data.data.redirect}})
            }
          } else {
            setAlertInfo({
              ...alertInfo,
              visible: true,
              cls: "danger",
              msg: response.data.data.msg,
            });
            //   setTimeout(() => {
            //     setAlertInfo({...alertInfo, 'visible': false,'cls':'danger','msg': ``});
            // }, 2000);
          }
        });
      }
    }
  };

  const renderButton = (buttonProps) => {
    // console.log(buttonProps)
    return (
      <span>
        {buttonProps.remainingTime !== 0
          ? `Please wait for ${buttonProps.remainingTime} sec`
          : ""}
      </span>
    );
  };
  const renderTime = (remainingTime) => {
    return React.Fragment;
  };

  return (
    <>
      <div
        className="sd-body mb-5 pb-4"
        style={
          reredirect === "/penta"
            ? { borderRadius: "32px 32px 0 0" }
            : { backgroundColor: "#001F2B", borderRadius: "32px 32px 0 0" }
        }
      >
        {!disabled ? (
          <div className="popUpBox">
            <div className="headSec">
              <h2>Welcome to IceSpice</h2>
              <p style={{ color: "grey", fontSize: "14px" }}>
                Please enter mobile, login and unlock awesome discount
              </p>
            </div>
            <div className="actSec">
              <div className="feildSec">
                <div className="form_outer countryCode">
                  <div className="contrySlct">+91</div>
                  <input
                    type="number"
                    inputMode="numeric"
                    className="form_control"
                    name="mobileNumber"
                    id="mobileNumber"
                    placeholder="Enter mobile number"
                    value={mobile}
                    onChange={(e) => {
                      if (e.target.value?.length <= 10) {
                        setMobile(e.target.value);
                      }
                    }}
                    autoComplete="off"
                    maxLength={10}
                    autoFocus={true}
                  />
                  {/* <label htmlFor="mobileNumber">Mobile Number</label> */}
                </div>
                <div className="signNwTxtInfo">
                  <div className="signUpTxt" style={{ color: "red" }}>
                    {alertInfos.msg}
                  </div>
                </div>
              </div>
              {/* <div className="textRight">
      <button type="button" className="btnLink">
        Use E-Mail
      </button>
    </div> */}
            </div>
            <div className="signNwTxtInfo">
              <div className="signUpTxt">
                By continuing, you agree to our{/* */}{" "}
                <a href="/terms" className="">
                  Terms of Use
                </a>{" "}
                {/* */}and{" "}
                <a href="/privacy" className="" style={{ paddingLeft: 0 }}>
                  Privacy Policy
                </a>
              </div>
            </div>
            <div className="actSec mb-20" style={{ display: "block" }}>
              <button
                type="button"
                name="Send_OTP"
                className="btnPrimary"
                disabled={mobile.length === 10 ? false : true}
                onClick={(e) => submitHandle(e)}
              >
                Continue
              </button>
            </div>
          </div>
        ) : (
          <div className="popUpBox popUpBoxOTP">
            <div className="headSec">
              {/* <h2 style={{marginBottom:"10px"}}>Welcome</h2> */}
              <p>OTP sent to registered number on +91 {mobile}</p>
            </div>
            <div className="otpFormSec">
              <div className="signNwTxtInfo">
                <div className="signUpTxt" style={{ color: "red" }}>
                  {alertInfo.msg}
                </div>
              </div>
              <OTPInput
                value={OTP}
                onChange={setOTP}
                autoFocus
                OTPLength={6}
                autocomplete="one-time-code"
                otpType="number"
                disabled={false}
                className="otpinputs"
              />
              <div className="flexRow50 justify_space">
                <div className="flexRow50Cols">
                  <button
                    type="button"
                    className="btnLink"
                    onClick={() => {
                      setAlertInfos({
                        ...alertInfo,
                        visible: false,
                        cls: "success",
                        msg: ``,
                      });
                      setDisabled(false);
                    }}
                  >
                    Edit Number
                  </button>
                </div>
                <div className="flexRow50Cols text-right">
                  <button
                    disabled={time}
                    type="button"
                    name="Send_OTP"
                    className="btnLink"
                    onClick={(e) => submitHandle(e)}
                  >
                    Resend OTP
                    {/* <ResendOTP className="btnLink" onResendClick={e => submitHandle(e)} renderButton={renderButton} renderTime={renderTime} maxTime={20}/> */}
                  </button>
                </div>
              </div>
            </div>
            <div className="actSec mt-80 mb-20">
              <button
                type="button"
                className="btnPrimary"
                id="validOtp"
                disabled={OTP.length === 6 ? false : true}
                onClick={(e) => submitHandle(e)}
                style={{ width: "80%" }}
              >
                Continue
              </button>
            </div>
          </div>
        )}
      </div>
      {reredirect !== "/penta" && <div>Hello</div>}
    </>
  );
};

export default BottomLoginDirect;
